export const ORGANIZATION_SETTINGS_TABS = [
  {
    name: 'sso-setup',
    permission: 'configureSso',
    title: 'Single Sign-On',
  },
  {
    name: 'user-roles',
    permission: 'manageGreenhouseRoles',
    title: 'User Roles',
  },
  {
    name: 'custom-fields',
    permission: 'manageCustomFields',
    title: 'Custom Fields',
  },
  {
    name: 'ai-settings',
    permission: 'configureAi',
    title: 'AI',
  },
  {
    name: 'job-post-settings',
    permission: 'manageJobPostSettings',
    title: 'Platform Settings',
  },
  {
    name: 'job-profile-settings',
    permission: 'editJobProfileSettings',
    title: 'Job Profiles',
  },
  {
    name: 'acknowledgements-settings',
    permission: 'editAcknowledgementsSettings',
    title: 'Acknowledgements',
  },
  {
    name: 'flsa-settings',
    permission: 'editFlsaSettings',
    title: 'Federal FLSA',
  },
  {
    name: 'approvals-settings',
    permission: 'editApprovalsSettings',
    title: 'Approvals',
  },
];

export const ORGANIZATION_SETTINGS_PERMISSIONS = ORGANIZATION_SETTINGS_TABS.map(
  ({ permission }) => permission,
);

export const getVisibleOrganizationSettingsTabs = (authDataStore) => (
  ORGANIZATION_SETTINGS_TABS.filter(({ permission }) => (
    authDataStore.checkRbacPermissions([permission])
  ))
);

export const getDefaultOrganizationSettingsRoute = (authDataStore) => {
  const tab = getVisibleOrganizationSettingsTabs(authDataStore)[0];

  return { name: tab?.name ?? 'account' };
};

export const canAccessOrganizationSettings = (authDataStore) => (
  authDataStore.checkOneOfPermissions(ORGANIZATION_SETTINGS_PERMISSIONS)
);
